<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Главная</a></li>
        <li>Предметные тесты</li>
      </ul>
      <h2>Список предметных тестов</h2>
    </div>
  </div>
</div>


<section class="banner-wrapper lessons-area ptb-50">
  <div class="container">
    <div class="flex-column align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="wrapper-content">
          <h1>Предметные тесты</h1>
        </div>
      </div>
      <div class="col-lg col-md">
        <div class="banner-courses-category">
          <ul>
            <li *ngFor="let lesson of lessons" class="p-1">
              <a (click)="onClick(lesson.link)">
                <i class='{{lesson.icon}}'></i>
                {{lesson.titleRu}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</section>

